import React from 'react';

// Auth Context
const AuthContext = React.createContext();

export default AuthContext;
